import { FC, useEffect, useMemo, useState } from "react";

import { ServiceTaskTypeEnum } from "@/domain/models/common";

import { DsText } from "../components/ui";
import { useTaskQuery } from "../data/queries/taskQueries";
import { dateAsDayjs, getFormattedDuration } from "../utils/date";

type TaskTimeCounterPropsType = {
  jobId: string;
  serviceId: string;
  taskId: ServiceTaskTypeEnum;
};

const TaskTimeCounter: FC<TaskTimeCounterPropsType> = ({
  jobId,
  serviceId,
  taskId,
}) => {
  const { data: taskData } = useTaskQuery({ jobId, serviceId, taskId });

  const [jobTakingSecondsDuration, setJobTakingSecondsDuration] = useState(0);

  const cleanupStartedAt = useMemo(
    () => taskData?.cleaningStartedAt,
    [taskData?.cleaningStartedAt],
  );

  useEffect(() => {
    if (cleanupStartedAt) {
      // Calc the difference between cleanupStartedAt and now and set it to jobTakingSecondsDuration
      const cleanupStartedAtAsDayJs = dateAsDayjs(cleanupStartedAt.toDate());

      const now = dateAsDayjs();
      const diff = now.diff(cleanupStartedAtAsDayJs, "seconds");

      setJobTakingSecondsDuration(diff);

      // Set a timer to update the jobTakingSecondsDuration every second
      const interval = setInterval(() => {
        setJobTakingSecondsDuration(currentTime => currentTime + 1);
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [cleanupStartedAt]);

  //Show the time in a human readable format
  return (
    <DsText className="text-2xl font-bold">
      {getFormattedDuration({
        units: jobTakingSecondsDuration,
        unitType: "seconds",
      })}
    </DsText>
  );
};

export { TaskTimeCounter };
